import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentmatter)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["top-matter-container timeline-scroller-gap", {
      'dynamic-visible': _ctx.dynamicVisible,
    }])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentmatter)))
      ], 2))
    : _createCommentVNode("", true)
}